// Single source of truth for the blog listing. public/data/blog/index.json is
// imported at BUILD time (not fetched at runtime) so the listing and its
// crawlable <a href="/blog/<slug>"> links are present in the React tree and get
// captured by scripts/prerender.mjs. The same index.json is also served as a
// static file for any runtime needs.
//
// Each post article body lives in public/data/blog/<slug>.md and is loaded by
// BlogPost.jsx at view time.
import raw from '../../public/data/blog/index.json';

// Newest first. Dates are ISO (YYYY-MM-DD) so string sort is chronological.
export const posts = [...raw].sort((a, b) => (a.date < b.date ? 1 : a.date > b.date ? -1 : 0));

// Unique tag list across all posts, preserving first-seen order.
export const allTags = (() => {
  const seen = new Set();
  const out = [];
  for (const p of posts) {
    for (const t of p.tags || []) {
      if (!seen.has(t)) {
        seen.add(t);
        out.push(t);
      }
    }
  }
  return out;
})();

export function getPost(slug) {
  return posts.find((p) => p.slug === slug) || null;
}

// Format an ISO date pinned to UTC so the server-prerendered string matches the
// client-hydrated string (no hydration mismatch across timezones).
export function formatDate(iso) {
  const d = new Date(`${iso}T00:00:00Z`);
  return d.toLocaleDateString('en-US', {
    year: 'numeric',
    month: 'long',
    day: 'numeric',
    timeZone: 'UTC',
  });
}
